
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ChatView from '@/components/chat/ChatView';

const PatientChatPage = () => {
  const { doctorId } = useParams<{ doctorId: string }>();
  const navigate = useNavigate();
  
  return (
    <div className="container mx-auto p-4 pb-20">
      <h1 className="text-2xl font-bold mb-4">Messages</h1>
      
      <ChatView
        onNavigateBack={() => navigate('/patient-area/messages')}
        onViewProfile={(id) => navigate(`/patient-area/doctor/${id}`)}
        userType="patient"
        conversationId={doctorId ? parseInt(doctorId) : undefined}
      />
    </div>
  );
};

export default PatientChatPage;
